import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelFiItemDefaultByCategoryHdrModel} from '../../../../../../models/aggregates/fm/category';
import {Core2Config} from '../../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelFiItemDefaultByCategoryService extends BaseApiTemplateService<LabelFiItemDefaultByCategoryHdrModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'default-by-category-hdr';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'default-by-category-hdr/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'default-by-category-hdr/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

}
